module.exports = __webpack_public_path__ + "media/wrong.820a7796.wav";